import { useTheme } from "@/hooks/useTheme"

import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  // Use custom theme hook instead of next-themes
  let theme = "light" as "light" | "dark" | "system";
  try {
    const themeContext = useTheme();
    // Map custom theme to sonner theme
    if (themeContext.theme === "dark") {
      theme = "dark";
    } else if (themeContext.theme === "sfs") {
      theme = "light"; // sfs theme uses light mode for sonner
    } else {
      theme = "light";
    }
  } catch {
    // Fallback if theme context is not available
    theme = "light";
  }

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-right"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
